import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import cabeceraCud from '../../assets/cabeceraCat.png';
import { useSelector, useDispatch } from 'react-redux';
import { fechaHoraActualBoliviaSoloVista } from '../../util/valueCalculator';
import { addFooter, addHeader, addTitles } from './TemplatePrintModals';

const CustomPrintModal2 = ({ show, handleClose, title1, title2, title3,title4, total1, total2, content, copia }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { nombre, usuario,rolActivo, roles,id } = useSelector(state => state.sesion);


    useEffect(() => {
        if (show) {
            generatePdf();
        }
    }, [show, content]);

    const generatePdf = () => {
        const doc = new jsPDF('p', 'pt', 'letter'); // Establecer tamaño de hoja a carta

        const marginLeftRight = 55; // Márgenes izquierdo y derecho
        const marginTop = 35; // Margen superior
        const marginBottom = 75; // Ajustar el margen inferior para bajar el pie de página
        const headerHeight = 60; // Altura de la cabecera

        const addWatermark = (doc) => {
            const pageHeight = doc.internal.pageSize.getHeight();
            const pageWidth = doc.internal.pageSize.getWidth();

            doc.setFontSize(72);
            doc.setTextColor(240, 240, 240); // marca de agua
            doc.setFont("helvetica", "bold");
            doc.text("B O R R A D O R", pageWidth / 2, pageHeight / 2, {
                angle: 45,
                align: 'center'
            });
        };
        // Validaciones: Asegurar que los valores no sean null o undefined
        const validTitle1 = title1 || '';
        const validTitle2 = title2 || '';
        const validTitle3 = title3 || '';
        const validTitle4 = title4 || '';
        const validTotal1 = total1 || '';
        const validTotal2 = total2 || '';
        

        // Inicializa el número de página
        let pageNumber = 0;

        const addTotals = (doc) => {
            const startY = doc.autoTable.previous.finalY + 18;
            doc.setFontSize(12);
            doc.setTextColor(0, 0, 0); // Asegurar que los totales estén en negro
            if (validTotal1) {
                doc.text(validTotal1, marginLeftRight, startY);
            }
            if (validTotal2) {
                doc.text(validTotal2, marginLeftRight, startY + 20);
            }
        };

        // Draw watermark on the first page before any content if copia is true
        if (copia) {
            addWatermark(doc);
        }
        const titles = {validTitle1, validTitle2, validTitle3,validTitle4};
        const margins = {marginLeftRight, marginTop, marginBottom};
        
        if (typeof content === 'string') {
            addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
            addTitles({doc, titles, margins, headerHeight});
            doc.text(content, marginLeftRight, marginTop + headerHeight + 80);
            addTotals(doc);
             addFooter({doc,marginLeftRight, marginBottom,nombre});
        } else {
            addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
            const startTableY = addTitles({doc, titles, margins, headerHeight});
            autoTable(doc, {
                head: content.head,
                body: content.body,
                startY: startTableY, // Debajo de la cabecera y los títulos
                margin: { top: startTableY, left: marginLeftRight, right: marginLeftRight, bottom: marginBottom +20 },
                didDrawPage: function (data) {
                    pageNumber++;
                    addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
                    if(pageNumber>1){addTitles({doc, titles, margins, headerHeight});}// Asegurar que los títulos aparezcan en cada página
                    if (copia) addWatermark(doc);
                    addFooter({doc,marginLeftRight, marginBottom,nombre});
                },
                styles: { 
                    fontSize:9,
                    lineColor: [0, 0, 0], // Color de borde (negro)
                    lineWidth: 0.5, // Grosor del borde más delgado
                },
                headStyles: {
                    fillColor: [255, 255, 255], // Fondo blanco para el encabezado
                    textColor: [0, 0, 0], // Texto negro para el encabezado
                    lineWidth: 0.5, // Grosor del borde del encabezado más delgado
                    lineColor: [0, 0, 0], // Color de borde del encabezado
                },
                bodyStyles: {
                    fillColor: [255, 255, 255], // Fondo blanco para el cuerpo
                    textColor: [0, 0, 0], // Texto negro para el cuerpo
                    lineWidth: 0.5, // Grosor del borde del cuerpo más delgado
                    lineColor: [0, 0, 0], // Color de borde del cuerpo
                },
                pageBreak: 'auto', // Permitir que el contenido salte a nuevas páginas
                rowPageBreak: 'avoid', // Evitar que las filas se dividan entre ppáginas
            });
            addTotals(doc);
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title1}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl && (
                    <iframe src={pdfUrl} width="100%" height="500px" title="Vista previa del Recibo"></iframe>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomPrintModal2;
